import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "../../../css/Products/AddProduct.css";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../SessionChecker/SessionChecker";
import AddHashtag from "./AddHashtag";
import { addProductRequest } from "./AddProductRequest";

function AddProduct({ theme }) {
  const { t } = useTranslation();

  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [caption, setCaption] = useState("");

  const [nameError, setNameError] = useState(false);
  const [priceError, setPriceError] = useState(false);
  const [imagesError, setImagesError] = useState(false);

  const [requestStatus, setRequestStatus] = useState(false);

  const [addHashtagStatus, setAddHashtagStatus] = useState(false);
  const [selectedHashtags, setSelectedHashtags] = useState([]);

  const [selectedImages, setSelectedImages] = useState([]);

  const [priceType, setPriceType] = useState('Toman');

  const navigate = useNavigate();

  useEffect(() => {}, []);

  const { currentUserUsername } = useContext(AuthContext);

  return (
    <div className="mainDiv">
      <div className={`headerDiv ${theme}`}>
        <div>{t("Add Product")}</div>
      </div>

      <div className="contentDiv">
        <div className={`addProductInfoDiv ${theme}`}>
          <div className="inputMainDiv">
            <div className="input_div">
              <div>{t("Name")}</div>

              <input
                className={`input dir_ltr ${theme} ${nameError ? "error" : ""}`}
                type="text"
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                  setNameError(false);
                }}
              />

              {nameError && (
                <div className="input_error_div">
                  {t("Please enter a name")}
                </div>
              )}
            </div>

            <div className="input_div">
              <div className="priceDiv">
                <div>{t("Price")}</div>
                <div className="priceTypeDiv" onClick={() =>{
                  if (priceType == 'Toman') {
                    setPriceType('Tron')
                  } else {
                    setPriceType('Toman')
                  }
                }}>{t(priceType)}</div>
              </div>

              <input
                className={`input dir_ltr ${theme} ${priceError ? "error" : ""}`}
                type="text"
                inputMode="numeric"
                value={price ? Number(price).toLocaleString("en-US") : ""}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  setPrice(value);
                  setPriceError(false);
                }}
              />

              {priceError && (
                <div className="input_error_div">
                  {t("Please enter a valid price")}
                </div>
              )}
            </div>

            <div className="hashtagsDiv">
              <button
                className="addHashtagButton"
                onClick={() => {
                  setAddHashtagStatus(true);
                }}
              >
                {t("add Hashtag")}
              </button>

              <div className="selectedHashtagsDiv noPaddingTop">
                {selectedHashtags.map((item, index) => {
                  return (
                    <div
                      className={`selectedHashtagDiv ${theme}`}
                      key={index}
                      onClick={() => {
                        setSelectedHashtags((prev) =>
                          prev.filter((_, i) => i !== index),
                        );
                      }}
                    >
                      {item}
                    </div>
                  );
                })}
              </div>

              {addHashtagStatus && (
                <AddHashtag
                  theme={theme}
                  setAddHashtagStatus={setAddHashtagStatus}
                  selectedHashtags={selectedHashtags}
                  setSelectedHashtags={setSelectedHashtags}
                ></AddHashtag>
              )}
            </div>

            <div className="input_div">
              <div>{t("Caption")}</div>

              <textarea
                className={`textarea ${theme}`}
                value={caption}
                onChange={(e) => {
                  setCaption(e.target.value);
                }}
              />
            </div>

            {/* Images */}

            <div className="input_div">
              <div>{t("Images")}</div>

              <div
                className={`imagesContainer ${theme} ${
                  imagesError ? "error" : ""
                }`}
              >
                <label htmlFor="productImages" className="addImageItem">
                  <span>+</span>
                </label>

                <input
                  id="productImages"
                  type="file"
                  accept="image/png,image/jpeg"
                  multiple
                  className="imageFileInput"
                  onChange={(e) => {
                    const files = Array.from(e.target.files);
                    setSelectedImages((prev) => [...prev, ...files]);
                  }}
                />

                {selectedImages.map((image, index) => (
                  <div
                    className="imagePreviewItem"
                    key={image.id}
                    onClick={() => {
                      setSelectedImages((prev) =>
                        prev.filter((_, i) => i !== index),
                      );
                    }}
                  >
                    <img src={URL.createObjectURL(image)} />
                  </div>
                ))}
              </div>

              {imagesError && (
                <div className="input_error_div">
                  {t("Please select at least one image")}
                </div>
              )}
            </div>
          </div>

          <div className="inputMainDiv">
            <button
              type="button"
              className={`submit_button ${theme}`}
              onClick={() => {
                addProductRequest(
                  name,
                  price,
                  priceType,
                  caption,
                  selectedHashtags,
                  selectedImages,
                  navigate,
                  currentUserUsername,
                );
              }}
            >
              {requestStatus.loading ? (
                <img src="/icons/loading.png" className="rotate" />
              ) : (
                t("Confirm")
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddProduct;
